import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask modal-mask-front"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "error" }
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = ["disabled"]

import { computed, toRef } from 'vue'

    import { EmailSenderFormSubmitEventPayload } from '@Evaluation/Estimations/Components/EmailSender'
    import type { EmailSenderViewModel } from '@Evaluation/Estimations/Components/EmailSender'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmailSender',
  props: {
    viewModel: {}
  },
  emits: ["form-submit"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const sending = computed(() => vm.value.sending)
    const recipientIds = computed(() => vm.value.recipientIds)

    const emailSubject = computed<string>({
        get: () => vm.value.emailSubject,
        set: val => { vm.value.emailSubject = val }
    })

    const emailBody = computed<string>({
        get: () => vm.value.emailBody,
        set: val => { vm.value.emailBody = val }
    })

    const emailBodyError = computed(() =>
        emailBody.value.indexOf('{url}') === -1
            ? '{url} is required in the message.'
            : null
    )

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        vm.value.sending = true

        const payload = new EmailSenderFormSubmitEventPayload(
            emailSubject.value,
            emailBody.value,
            recipientIds.value
        )

        emit('form-submit', payload)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, "Send email (" + _toDisplayString(recipientIds.value.length) + ")", 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "email-sender-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", null, "Subject:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailSubject).value = $event)),
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        emailSubject.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "5",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailBody).value = $event)),
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        emailBody.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(emailBodyError.value), 1 /* TEXT */)
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Close"),
                _createElementVNode("button", {
                  type: "submit",
                  form: "email-sender-form",
                  disabled: sending.value,
                  class: "btn btn-primary"
                }, "Send email", 8 /* PROPS */, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})